<template>
  <summary-detail :name="platformName" type="平台" :year="year">
    <order-module :search-condition="$route.query" :year="year" :platform-name="platformName"/>
    <el-divider/>
    <other-module :search-condition="$route.query" :year="year" :platform-name="platformName"/>
  </summary-detail>
</template>

<script>

import OrderModule from "../../components/summary/PlatformDetail/orderModule";
import OtherModule from "../../components/summary/PlatformDetail/otherModule";
import SummaryDetail from "@/views/dashboard/components/Detail.vue";

export default {
  name: "SummaryArtistDetail",
  components: {SummaryDetail, OtherModule, OrderModule},
  data() {
    return {
      platformName: this.$route.query.platformName,
      year: this.$route.query.year,
      organization_id: this.$route.query.organization_id,
      data: [],
      dataOrderTable: [],
      dataOrderTableHeader: [],
      total_count: 0,
      total_money: 0,
    }
  },
  created() {
    this.getOrderData();
  },
  methods: {
    getOrderData() {
    },
    getSummaries() {
      return ['合计', this.total_count, this.total_money];
    }
  }
}
</script>

<style>

</style>
